import { useState, useEffect } from 'react';
import { DT } from '../theme/designTokens';

export type Breakpoint = 'mobile' | 'tablet' | 'desktop';

function getBreakpoint(): Breakpoint {
  if (typeof window === 'undefined') return 'mobile';
  const w = window.innerWidth;
  if (w >= DT.breakpoint.desktop) return 'desktop';
  if (w >= DT.breakpoint.tablet)  return 'tablet';
  return 'mobile';
}

/**
 * Returns the current responsive breakpoint, updated on window resize.
 *
 * Prefer CSS-based breakpoints (Tailwind md:/lg: classes) for layout.
 * Use this hook only when JS needs to decide which JSX branch to render —
 * e.g. GameScreen layout switch in Phase 4.
 */
export function useBreakpoint(): Breakpoint {
  const [bp, setBp] = useState<Breakpoint>(getBreakpoint);

  useEffect(() => {
    const handler = () => setBp(getBreakpoint());
    window.addEventListener('resize', handler, { passive: true });
    return () => window.removeEventListener('resize', handler);
  }, []);

  return bp;
}

export function useIsMobile():  boolean { return useBreakpoint() === 'mobile';  }
export function useIsTablet():  boolean { return useBreakpoint() === 'tablet';  }
export function useIsDesktop(): boolean { return useBreakpoint() === 'desktop'; }
